export default [
  {
    $el: 'div',
    children: [
      {
        $el: 'div',
        attrs: {
          class: 'grid grid-cols-1 md:grid-cols-2 gap-3 mb-3 w-full',
        },
        children: [
          {
            '$formkit': 'text',
            'name': 'first_name',
            'validation-label': 'First name',
            'validation': 'required',
            'placeholder': 'Enter your first name',
            'label': 'First name',
          },
          {
            '$formkit': 'text',
            'name': 'last_name',
            'validation-label': 'Last name',
            'validation': 'required',
            'placeholder': 'Enter your last name',
            'label': 'Last name',
          },
          {
            '$formkit': 'text',
            'name': 'email',
            'validation-label': 'Email',
            'validation': 'required|email',
            'placeholder': 'Enter your email address',
            'label': 'Email',
          },
          {
            $formkit: 'ComponentWrapper',
            component: 'SeComboBox',
            componentProps: {
              id: 'countries',
              items: '$countries',
              placeholder: 'Search for a country',
            },
            id: 'country',
            label: 'Nationality',
            name: 'country',
            validation: 'required',
          },
          {
            $el: 'div',
            if: '$isSADCMember($get(country).value) === true',
            attrs: {
              class: 'col-span-1 md:col-span-2 bg-info rounded-md p-2 lg:p-3 bg-opacity-30',
            },
            children: [
              {
                $el: 'p',
                children: 'As a SADC member, you qualify for special rates. South African citizens, please enter your ID number. Other SADC nationals, please provide your passport number. You will need to present the relevant document at check-in.',
                attrs: {
                  class: 'text-sm text-info font-semibold mb-2',
                },
              },

              {
                '$formkit': 'text',
                'name': 'identity_number',
                'validation-label': 'ID number',
                'placeholder': 'Enter your ID number',
                'validation': 'required|isValidSADCId',
                'validationRules': '$validationRules',
                'validation-messages': {
                  isValidSADCId: 'That is not a valid ID number',
                },
              }],
          },
          {
            '$formkit': 'password',
            'name': 'password',
            'placeholder': 'Enter a password',
            'validation-label': 'Password',
            'validation': 'required',
            'label': 'Password',
          },
          {
            '$formkit': 'password',
            'name': 'password_confirm',
            'placeholder': 'Confirm your password',
            'validation-label': 'Password confirmation',
            'validation': 'required|confirm',
            'label': 'Confirm password',
          },
        ],
      },
    ],
  },
];
